import { useMemo } from 'react'
import { useTasks } from '@/hooks/useTasks'
import { useInfiniteTasks } from '@/hooks/useInfiniteTasks'
import { useAccessControlFilterFn } from '@/hooks/useAccessControlFilter'

export function useAccessControlledTasks() {
  const { data: tasks, isLoading } = useTasks()
  const { filterItems, isReady } = useAccessControlFilterFn('taskId')

  const filteredTasks = useMemo(() => {
    if (!tasks || !isReady) return tasks
    return filterItems(tasks)
  }, [tasks, isReady, filterItems])

  return { data: filteredTasks, isLoading }
}

export function useAccessControlledInfiniteTasks() {
  const infiniteResult = useInfiniteTasks()
  const { filterItems, isReady } = useAccessControlFilterFn('taskId')

  const filteredData = useMemo(() => {
    if (!infiniteResult.data?.pages || !isReady) return infiniteResult.data

    return {
      ...infiniteResult.data,
      pages: infiniteResult.data.pages.map((page) => ({
        ...page,
        tasks: filterItems(page.tasks),
      })),
    }
  }, [infiniteResult.data, isReady, filterItems])

  return { ...infiniteResult, data: filteredData }
}
